import { useTranslation } from "react-i18next";

export default function EditorialBriefDetails({ idea }) {
  const { t } = useTranslation();
  if (!idea?.validacion?.estado) return null;
  const refs = Array.isArray(idea.referencias) ? idea.referencias : [];
  return (
    <details className="text-sm text-slate-600 my-3" data-testid="editorial-brief">
      <summary className="cursor-pointer font-semibold">
        {t("editorial.details")} · {t(`editorial.${idea.validacion.estado}`)}
      </summary>
      <div className="mt-2 space-y-2">
        {idea.idea_madre?.idea_madre && <p><b>{t("editorial.mother")}:</b> {idea.idea_madre.idea_madre}</p>}
        {idea.palanca && <p><b>{t("editorial.lever")}:</b> {t(`editorial.levers.${idea.palanca}`)}</p>}
        {idea.diferencia && <p><b>{t("editorial.difference")}:</b> {idea.diferencia}</p>}
        {idea.estructura_titulo?.titulo_original && <p><b>{t("editorial.titleSource")}:</b> {idea.estructura_titulo.titulo_original}</p>}
        {[["promise", idea.promesa], ["thumbnail", idea.miniatura],
          ["duration", idea.duracion_motivo], ["continuity", idea.continuidad]].map(([key, value]) =>
          value ? <p key={key}><b>{t(`editorial.${key}`)}:</b> {value}</p> : null)}
        {refs.map((ref) => (
          <div key={ref.video_id}>
            <a className="text-blue-700 underline" target="_blank" rel="noopener noreferrer"
              href={`https://www.youtube.com/watch?v=${encodeURIComponent(ref.video_id)}`}>
              {ref.titulo}
            </a>
            <p>{ref.canal}{ref.origin === "propio" ? ` · ${t("editorial.own")}` : ""}</p>
            <p>{Number.isFinite(ref.outlier)
              ? t("editorial.comparison", { score: ref.outlier, count: ref.sample_size })
              : t("editorial.insufficient")}</p>
            {ref.motivo && <p>{ref.motivo}</p>}
          </div>
        ))}
        <p className="text-xs text-slate-500">{t("editorial.limits")}</p>
      </div>
    </details>
  );
}
